import React, {Component} from 'react';
import BusinessRepo from '../../repository/business';
import {Button, Icon, message, Table, Typography} from 'antd';
import {LoadingIcon} from '../../components/loading';
import BusinessNew from "./components/new";

const { Title } = Typography;

class BusinessIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      businesses: [],
      newOpen: false,
    }
  }

  componentDidMount() {
    this.fetchBusinesses()
  }

  fetchBusinesses() {
    BusinessRepo.all().then(
      result => {
        this.setState({
          businesses: result.data.businesses,
        })
      },
      error => {
        console.log(error.response);
        message.error('Error fetching businesses')
      }
    )
  }

  showDetails(bizID) {
    this.props.history.push(`/business/${bizID}`)
  }

  render() {
    const columns = [
      {
        title: "Name",
        key: "name",
        dataIndex: "name",
      },
      {
        title: "Slug",
        key: "slug",
        dataIndex: "slug",
      },
      {
        title: "",
        key: "action",
        render: record => {
          return (
            <div>
              <Button type="link" onClick={() => this.showDetails(record.id)}>
                Details
              </Button>
            </div>
          )
        }
      }
    ];

    return (
      <>
        <Title level={2}>Businesses</Title>
        <Button
          key="add-business"
          style={{ margin: 10 }}
          onClick={() => { this.setState({newOpen: true}) }}
        >
          <Icon type="plus" /> Add business
        </Button>

        <BusinessNew visible={this.state.newOpen} close={() => {
          this.setState({newOpen: false})
        }} />

        <Table
          dataSource={this.state.businesses}
          loading={{
            indicator: LoadingIcon,
            tip: "Loading...",
            size: "large",
            spinning: this.state.businesses.length < 1,
          }}
          rowKey="id"
          pagination={false}
          columns={columns}
        />
      </>
    );
  }
}

export default BusinessIndex;